import Vue from "vue";
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

import VueResource from 'vue-resource';
Vue.use(VueResource);

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
Vue.use(PaperDashboard);


import App from "./App";
import router from "./router/index";
import { store } from './store';

/* eslint-disable no-new */

let app;

firebase.auth().onAuthStateChanged((firebaseUser) => {
  app = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created () {
      // firebase.auth().onAuthStateChanged((firebaseUser) => {
        if (firebaseUser) {
          store.dispatch('autoSignIn', firebaseUser)
        }
      // });
    }
  });
});

String.prototype.toCamelCase = function() {
    const capitalize = str => str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
    let string = this.toLowerCase().replace(/[^A-Za-z0-9]/g, ' ').split(' ').reduce((result, word) => result + capitalize(word.toLowerCase()));
    return string.charAt(0).toLowerCase() + string.slice(1);
}

String.prototype.validateEmail = function() {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(this.toLowerCase());
}
